import { render } from "./A00124.vue?vue&type=template&id=2b388c34&ts=true"
import script from "./A00124.vue?vue&type=script&lang=ts"
export * from "./A00124.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__